import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";

export default function AdminSettings() {
    const [form, setForm] = useState({ whatsapp_to: "", email_to: "", showcase_rotation_seconds: 6 });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        (async () => {
            const { data } = await api.get("/admin/settings");
            setForm({
                whatsapp_to: data.whatsapp_to || "",
                email_to: data.email_to || "",
                showcase_rotation_seconds: data.showcase_rotation_seconds || 6,
            });
            setLoading(false);
        })();
    }, []);

    const submit = async (e) => {
        e.preventDefault();
        setSaving(true);
        try {
            await api.post("/admin/settings", {
                ...form,
                showcase_rotation_seconds: Number(form.showcase_rotation_seconds) || 6,
            });
            toast.success("Configurações salvas");
        } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
        finally { setSaving(false); }
    };

    if (loading) return <div className="p-8 font-mono text-sm text-neutral-500">carregando…</div>;

    return (
        <div className="p-8 max-w-2xl">
            <div className="text-xs font-mono uppercase tracking-[0.24em] text-neutral-500">Configurações</div>
            <h1 className="mt-1 font-heading font-black text-3xl tracking-tight">Ajustes gerais</h1>
            <p className="mt-2 text-sm text-neutral-500">Notificações de orçamento e comportamento da landing page.</p>

            <form onSubmit={submit} className="mt-8 space-y-6" data-testid="settings-form">
                <div className="bg-white border border-neutral-300 p-6 space-y-5">
                    <div className="text-xs font-mono uppercase tracking-widest text-brand-blue">// notificações de orçamento</div>
                    <label className="block">
                        <span className="text-xs font-mono uppercase tracking-widest text-neutral-500">WhatsApp destino (E.164 · ex: +5511999999999)</span>
                        <input value={form.whatsapp_to} onChange={(e) => setForm({...form, whatsapp_to: e.target.value})} placeholder="+55..." className="mt-1 w-full h-11 px-3 border border-neutral-300 focus:outline-none focus:border-brand-blue" data-testid="settings-whatsapp" />
                    </label>
                    <label className="block">
                        <span className="text-xs font-mono uppercase tracking-widest text-neutral-500">E-mail destino</span>
                        <input type="email" value={form.email_to} onChange={(e) => setForm({...form, email_to: e.target.value})} placeholder="vendas@alfatek.com.br" className="mt-1 w-full h-11 px-3 border border-neutral-300 focus:outline-none focus:border-brand-blue" data-testid="settings-email" />
                    </label>
                </div>

                <div className="bg-white border border-neutral-300 p-6 space-y-5">
                    <div className="text-xs font-mono uppercase tracking-widest text-brand-blue">// landing page — showcase de produtos</div>
                    <label className="block">
                        <span className="text-xs font-mono uppercase tracking-widest text-neutral-500">Intervalo de rotação (segundos · 3 a 60)</span>
                        <input
                            type="number"
                            min={3}
                            max={60}
                            step={1}
                            value={form.showcase_rotation_seconds}
                            onChange={(e) => setForm({...form, showcase_rotation_seconds: e.target.value})}
                            className="mt-1 w-40 h-11 px-3 border border-neutral-300 focus:outline-none focus:border-brand-blue"
                            data-testid="settings-showcase-rotation"
                        />
                        <div className="mt-1 text-[11px] font-mono text-neutral-500">Tempo entre uma tela de produtos e a próxima. Recomendado: 6–10s.</div>
                    </label>
                </div>

                <button disabled={saving} data-testid="settings-save" className="h-11 px-6 bg-brand-blue text-white font-heading font-bold uppercase tracking-wider text-sm hover:bg-brand-blue-hover disabled:opacity-60 flex items-center gap-2">
                    <Save size={14} /> {saving ? "salvando…" : "Salvar"}
                </button>
            </form>

            <div className="mt-6 border border-dashed border-neutral-300 p-4 text-xs font-mono text-neutral-500 leading-relaxed">
                Twilio (WhatsApp) e Emergent Resend (e-mail) leem credenciais de <code>/app/backend/.env</code>. Se ausentes, os envios ficam registrados com status <span className="text-red-600">✗</span> no painel de Orçamentos — sem quebrar o site.
            </div>
        </div>
    );
}
